import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { ExcelWorkBook } from '../models/excel-work-book.model';
import { injectExcelMetadata } from './excel-metadata.helper';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, take } from 'rxjs';
import { DtoHasApi } from 'src/core/models/shared/dto-has-api.model';
import { environment } from 'src/environments/environment';
import { ExcelService } from 'src/core/services/excel/excel.service';

@Injectable({
  providedIn: 'root',
})
export class ClientExcelService {
  constructor(private http: HttpClient, private excelService: ExcelService) {}

  generateAndDownload(config: ExcelWorkBook, asCsv: boolean = false) {
    const workbook = new Workbook();
    workbook.creator = 'Conversational Intelligence';
    workbook.lastModifiedBy = 'Conversational Intelligence';

    config.worksheets.forEach(worksheet => {
      const worksheetObj = workbook.addWorksheet(worksheet.title, {
        properties: worksheet.properties,
      });

      worksheet.rows.forEach(row => {
        const cellValues = row.cells.map(({ value }) => value);
        const addedExcelRow = worksheetObj.addRow(cellValues);

        if (row.mergeOptions) {
          const splittedOptions = row.mergeOptions.split(':');
          worksheetObj.mergeCells(
            splittedOptions[0] + addedExcelRow.number,
            splittedOptions[1] + addedExcelRow.number
          );
        }

        for (let i = 0; i < row.cells.length; i++) {
          const cell = row.cells[i];
          if (cell.properties != null) {
            let addedCell = addedExcelRow.getCell(i + 1);
            addedCell.style = cell.properties;
            if (cell.properties.width) {
              worksheetObj.getColumn(i + 1).width = cell.properties.width;
            }
          }
        }

        if (row.fill) {
          addedExcelRow.fill = row.fill;
        }
      });
    });
    if (asCsv) {
      const options = {
        formatterOptions: {
          delimiter: ';',
        },
      };
      workbook.csv.writeBuffer(options).then(data => {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        fs.saveAs(blob, config.fileName);
      });
    } else {
      workbook.xlsx.writeBuffer().then(async data => {
        const patched = await injectExcelMetadata(data as ArrayBuffer);
        const blob = new Blob([patched], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        fs.saveAs(blob, config.fileName);
        const fileSizeInKB = patched.byteLength / 1024;
        this.excelService.setExcelAuditLog(config.fileName, fileSizeInKB).pipe(take(1)).subscribe();
      });
    }
  }
}
